import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailDetailsActionLocation from '../enums/TrailDetailsActionLocation';

type logTrailDetailsHitTheTrailButtonClickedParams = {
  hit_the_trail_button_location?: TrailDetailsActionLocation;
  trail_id?: string;
};

/**
 * User clicks 'hit the trail' on a web trail page.
 * @param params - Attributes to log with the amplitude event
 * @param params.hit_the_trail_button_location - The hit the trail button's location on the trail details page.
 * @param params.trail_id - Trail page user was on when they clicked the 'hit the trail' button.
 */
const logTrailDetailsHitTheTrailButtonClicked = (
  { hit_the_trail_button_location, trail_id }: logTrailDetailsHitTheTrailButtonClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details hit the trail button clicked',
    { 'hit the trail button location': hit_the_trail_button_location, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsHitTheTrailButtonClicked;
